export default "__VITE_ASSET__CHJJ4ylB__"